import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    componentNames: [],
    message: undefined,
    depth20message: undefined,
    socket: null,
    isConnected: false,
    heartBeat: undefined,
    optionChainMsg: undefined,
    greeksMsg: undefined,
    solacesocket: null,
    isSolaceConnected: false,
};
export const wsSlice = createSlice({
    name: "ws",
    initialState: initialState,
    reducers: {
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        set20DepthMessage: (state, action) => {
            state.depth20message = action.payload;
        },
        setGreeksMsg: (state, action) => {
            state.greeksMsg = action.payload;
        },
        setSocket: (state, action) => {
            state.socket = action.payload;
        },
        setConnected: (state, action) => {
            state.isConnected = action.payload;
        },
        setHeartBeat: (state, action) => {
            state.heartBeat = action.payload;
        },
        setSolaceSocket: (state, action) => {
            state.socket = action.payload;
        },
        // setSolaceConnected: (
        //   state,
        //   action: PayloadAction<SliceState["isSolaceConnected"]>
        // ) => {
        //   console.log("display", action.payload);
        //   state.isSolaceConnected = action.payload;
        // },
    },
});
export const { setMessage, set20DepthMessage, setSocket, setConnected, setHeartBeat, setGreeksMsg, setSolaceSocket,
// setSolaceConnected,
 } = wsSlice.actions;
export default wsSlice.reducer;
